import { SxProps, Theme } from '@mui/material';

export default <Sxes extends Array<any> = Array<SxProps<Theme>>>(...styles: Sxes): SxProps<Theme> =>
  styles.reduce((acc, style) => {
    const res = { ...acc, ...style };
    return res;
  }, {});
